// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { ThemeProvider as StyledThemeProvider } from 'styled-components';
// import { lightTheme, darkTheme } from '../styles/theme.js';

// const ThemeContext = createContext(undefined);

// export const ThemeProvider = ({ children }) => {
//   const [themeMode, setThemeMode] = useState(() => {
//     // Don't use localStorage during SSR
//     if (typeof window !== 'undefined') {
//       const savedTheme = localStorage.getItem('theme');
//             console.log("🚀 ~ ThemeProvider ~ savedTheme:", savedTheme)

//       return savedTheme || 'light';
//     }
//     return 'light';
//   });

//   useEffect(() => {
//     if (typeof window !== 'undefined') {
//       localStorage.setItem('theme', themeMode);
//       document.body.dataset.theme = themeMode;
//     }
//   }, [themeMode]);

//   const toggleTheme = () => {
//     setThemeMode(prev => (prev === 'light' ? 'dark' : 'light'));
//   };

//   const currentTheme = themeMode === 'light' ? lightTheme : darkTheme;

//   return (
//     <ThemeContext.Provider value={{ themeMode, toggleTheme }}>
//       <StyledThemeProvider theme={currentTheme}>
//         {children}
//       </StyledThemeProvider>
//     </ThemeContext.Provider>
//   );
// };

// export const useTheme = () => {
//   const context = useContext(ThemeContext);
//   if (context === undefined) {
//     throw new Error('useTheme must be used within a ThemeProvider');
//   }
//   return context;
// }; 



// ThemeProvider.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { createTheme } from '../styles/theme.js';

const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('themeMode') || 'light';
    }
    return 'light';
  });

  const [colorVariant, setColorVariant] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('colorVariant') || 'default';
    }
    return 'default';
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('themeMode', themeMode);
      localStorage.setItem('colorVariant', colorVariant);
      document.body.dataset.theme = themeMode;
    }
  }, [themeMode, colorVariant]);

  const toggleTheme = () => {
    setThemeMode((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  const selectColorVariant = (variant) => {
    setColorVariant(variant);
  };

  const currentTheme = createTheme(colorVariant, themeMode);

  return (
    <ThemeContext.Provider value={{ themeMode, toggleTheme, colorVariant, selectColorVariant }}>
      <StyledThemeProvider theme={currentTheme}>
        {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
